import React from 'react';

/**
 * AslSphere — bioluminescent placeholder for the ASL avatar.
 * patterns: 'idle' | 'pulse_strong' | 'wave_flow' | 'rotate_double'
 *
 * Architecture note: when real ASL videos are wired in, replace the inner
 * sphere with a <video> element keyed off `asl_video_url`. The container
 * + ring + particles stay as fallback / loading state.
 *
 * `showMessage` (default false) renders the AI partner guidance text
 * underneath the sphere — used by CandidateView when not yet answered.
 */
export default function AslSphere({
  pattern = 'idle',
  size = 240,
  asl_video_url = null,
  showMessage = false,
}) {
  const cls = pattern && pattern !== 'idle' ? `asl-pattern-${pattern}` : '';
  return (
    <div className="asl-sphere-wrap" data-testid="asl-sphere-wrap">
      <div
        className={`asl-sphere ${cls}`}
        style={{ width: size, height: size }}
        data-testid="asl-sphere"
        data-pattern={pattern}
        aria-label="Avatar de lengua de señas"
      >
        <div className="asl-sphere-core" />
        <div className="asl-sphere-halo" />
        <div className="asl-sphere-ring" />
        <span className="asl-sphere-particle p1" />
        <span className="asl-sphere-particle p2" />
        <span className="asl-sphere-particle p3" />
        <span className="asl-sphere-particle p4" />
        <span className="asl-sphere-particle p5" />
        <span className="asl-sphere-particle p6" />
        {asl_video_url && (
          <video
            className="asl-sphere-video"
            src={asl_video_url}
            autoPlay
            muted
            loop
            playsInline
            aria-hidden="true"
          />
        )}
      </div>
      {showMessage && (
        <p className="ai-partner-message" data-testid="ai-partner-message">
          I am here to guide you through this process
        </p>
      )}
    </div>
  );
}
